
<ng-container *ngIf="(loaderService.isLoading | async) || !isLoaded">
  <app-flight-result-loader></app-flight-result-loader>
</ng-container>
<div class="roundWayTrip" *ngIf="isLoaded && domesticFlightJourneys && domesticFlightJourneys.length > 0">
  <div class="roundTrip">
    <div class="wrapper">
      <div class="flightNameDate">
        <p>{{domesticFlightJourneys[0]?.flightjourneys[0]?.flightlegs[0][0]?.origin_name}}<img
            src="../../../../assets/svgIcon/arrow_long_right.svg" alt="">
          <span *ngIf="domesticFlightJourneys[0]?.flightjourneys[0]?.flightlegs[0].length === 1">
            {{domesticFlightJourneys[0]?.flightjourneys[0]?.flightlegs[0][0]?.destination_name}}
          </span>
          <span *ngIf="domesticFlightJourneys[0]?.flightjourneys[0]?.flightlegs[0].length === 2">
            {{domesticFlightJourneys[0]?.flightjourneys[0]?.flightlegs[0][1]?.destination_name}}
          </span>
          <span *ngIf="domesticFlightJourneys[0]?.flightjourneys[0]?.flightlegs[0].length === 3">
            {{domesticFlightJourneys[0]?.flightjourneys[0]?.flightlegs[0][2]?.destination_name}}
          </span>

        </p>

        <p>{{domesticFlightJourneys[0]?.flightjourneys[0]?.flightlegs[0][0]?.depdate | date : "MMM d, y"}}</p>

      </div>
      <div class="shorting">
        <div class="shortFirst">
          <button mat-button>Sort By:</button>
        </div>
        <div class="shortMiddle">
          <div class="middleFirst" (click)="sortByOriginDepart()">
            <button mat-button [ngClass]="isOriginDepart?'activeColor':''">Depart
              <mat-icon class="material-icons"> {{isOriginDepart ? 'arrow_downward' : 'arrow_upward'}}</mat-icon>
            </button>
          </div>
          <div class="middleSecond" (click)="sortByOriginDuration()">
            <button mat-button [ngClass]="isOriginDuration?'activeColor':''">Duration
              <mat-icon class="material-icons"> {{isOriginDuration ? 'arrow_downward' : 'arrow_upward'}}</mat-icon>
            </button>
          </div>
          <div class="middleThird" (click)="sortByOriginArrive()">
            <button mat-button [ngClass]="isOriginArrive?'activeColor':''">Arrive
              <mat-icon class="material-icons"> {{isOriginArrive ? 'arrow_downward' : 'arrow_upward'}}</mat-icon>
            </button>
          </div>
        </div>
        <div class="shortSecondLast" (click)="sortOriginByPrice()">
          <button mat-button [ngClass]="isOriginPriceAsc?'activeColor':''">Price<mat-icon class="material-icons">
              {{isOriginPriceAsc ? 'arrow_downward' :
              'arrow_upward'}}
            </mat-icon></button>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="flightNameDate">
        <p>{{domesticFlightJourneys[1]?.flightjourneys[0]?.flightlegs[0][0]?.origin_name}}<img
            src="../../../../assets/svgIcon/arrow_long_right.svg" alt="">
          <span *ngIf="domesticFlightJourneys[1]?.flightjourneys[0]?.flightlegs[0].length === 1">
            {{domesticFlightJourneys[1]?.flightjourneys[0]?.flightlegs[0][0]?.destination_name}}
          </span>
          <span *ngIf="domesticFlightJourneys[1]?.flightjourneys[0]?.flightlegs[0].length === 2">
            {{domesticFlightJourneys[1]?.flightjourneys[0]?.flightlegs[0][1]?.destination_name}}
          </span>
          <span *ngIf="domesticFlightJourneys[1]?.flightjourneys[0]?.flightlegs[0].length === 3">
            {{domesticFlightJourneys[1]?.flightjourneys[0]?.flightlegs[0][2]?.destination_name}}
          </span>

        </p>
        <p>{{domesticFlightJourneys[1]?.flightjourneys[0]?.flightlegs[0][0]?.depdate | date : "MMM d, y"}}</p>
      </div>
      <div class="shorting">
        <div class="shortFirst">
          <button mat-button>Sort By:</button>
        </div>
        <div class="shortMiddle">
          <div class="middleFirst" (click)="sortByDestinationDepart()">
            <button mat-button [ngClass]="isDestinationDepart?'activeColor':''">Depart
              <mat-icon class="material-icons"> {{isDestinationDepart ? 'arrow_downward' : 'arrow_upward'}}</mat-icon>
            </button>
          </div>
          <div class="middleSecond" (click)="sortByDestinationDuration()">
            <button mat-button [ngClass]="isDestinationDuration?'activeColor':''">Duration
              <mat-icon class="material-icons"> {{isDestinationDuration ? 'arrow_downward' : 'arrow_upward'}}</mat-icon>
            </button>
          </div>
          <div class="middleThird" (click)="sortByDesitnationArrive()">
            <button mat-button [ngClass]="isDesitnationArrive?'activeColor':''">Arrive
              <mat-icon class="material-icons"> {{isDesitnationArrive ? 'arrow_downward' : 'arrow_upward'}}</mat-icon>
            </button>
          </div>
        </div>
        <div class="shortSecondLast" (click)="sortDestinationByPrice()">
          <button mat-button [ngClass]="isDestinationPriceAsc?'activeColor':''">Price<mat-icon class="material-icons">
              {{isDestinationPriceAsc ? 'arrow_downward' :
              'arrow_upward'}}
            </mat-icon></button>
        </div>
      </div>
    </div>
  </div>
  <section class="itinerarySction roundWayItinerary">
    <div class="roundTripCol">
      <mat-card *ngFor="let item of domesticFlightJourneys[0]?.flightjourneys;let i =index" [ngClass]="{'selected': selectedItem == item}"
        (click)="select(item)">
        <div matRipple matRippleCentered [ngClass]="{'selected': selectedItem == subItem}"
          *ngFor="let subItem of item.flightlegs">
          <!-- *ngIf="subItem[0]?.origin === this.flightRequest?.origin" -->
          <div class="flightInformation">
            <div class="flightInfo">
              <img
                [src]="subItem[0]?.carrierImage ? subItem[0]?.carrierImage : '../../../assets/b2c/flight/flight-dummy.png'"
                [alt]="subItem[0].carriername" class="img-fluid">
              <div class="carrierInfo">
                <p class="carriername" [matTooltip]="subItem[0].carriername">{{subItem[0].carriername}}</p>
                <p class="carrierNumber">{{subItem[0].carrier}}-{{subItem[0].flightnumber}}
                  <span *ngIf="subItem.length === 2"
                    class="stopageVia">,<br>{{subItem[1].carrier}}-{{subItem[1].flightnumber}}</span>
                  <span *ngIf="subItem.length === 3"
                    class="stopageVia">,<br>{{subItem[2].carrier}}-{{subItem[2].flightnumber}}</span>
                </p>
              </div>
            </div>
            <div class="flightTimeInfo">
              <div class="middleFirst">
                <p>{{utilities.transfromTimeToHourMin(subItem[0].deptime)}}<br><span>{{subItem[0].origin_name.slice(0,
                    -5)}}</span></p>
              </div>
              <div class="middleSecond">
                <div class="timeDuration">
                  <p>{{item.totaljourneyduration * 1000 * 60 | date: 'H' : 'UTC'}}h {{item.totaljourneyduration * 1000 *
                    60 | date: 'm' : 'UTC'}}m
                  </p>
                  <!-- <p *ngIf="subItem.length === 1">{{subItem[0].journeyduration * 1000 * 60 | date: 'h' : 'UTC'}}h
                    {{subItem[0].journeyduration * 1000 * 60 | date: 'm' : 'UTC'}}m
                  </p>
                  <p *ngIf="subItem.length === 2">{{subItem[0].journeyduration + subItem[1].journeyduration * 1000 *
                    60 | date: 'h' : 'UTC'}}h {{subItem[0].journeyduration + subItem[1].journeyduration * 1000 *
                    60 | date: 'm' : 'UTC'}}m</p>
                  <p *ngIf="subItem.length === 3">{{subItem[0].journeyduration + subItem[2].journeyduration * 1000 *
                    60 | date: 'h' : 'UTC'}}h {{subItem[0].journeyduration + subItem[2].journeyduration * 1000 *
                    60 | date: 'm' : 'UTC'}}m</p> -->
                  <div class="distanceLine">
                    <span></span>
                    <span *ngIf="subItem.length === 2" class="stopagePoint"><span class="one-stop"></span></span>
                  </div>
                  <ng-container>
                    <p *ngIf="subItem.length === 1" class="stopageVia">Non stop</p>
                    <p *ngIf="subItem.length === 2" class="stopageVia"><b>1 Stop</b> via
                      {{subItem[1].origin_name.slice(0,
                      -5)}}</p>
                    <p *ngIf="subItem.length === 3" class="stopageVia" matTooltip=" {{subItem[1].origin_name.slice(0,
                        -5)}} and {{subItem[2]?.origin_name.slice(0, -5)}}"><b>2 Stops </b>via
                      {{subItem[1].origin_name.slice(0,
                      -5)}}
                      and ...
                    </p>
                  </ng-container>
                </div>
              </div>
              <div class="middleThird">
                <!-- {{subItem | json}} -->
                <ng-container>
                  <p *ngIf="subItem.length === 1">
                    {{utilities.transfromTimeToHourMin(subItem[0].arrtime)}}<br><span>{{subItem[0].destination_name.slice(0,
                      -5)}}</span></p>
                  <p *ngIf="subItem.length === 2">
                    {{utilities.transfromTimeToHourMin(subItem[1].arrtime)}}<br><span>{{subItem[1].destination_name.slice(0,
                      -5)}}</span></p>
                  <p *ngIf="subItem.length === 3">
                    {{utilities.transfromTimeToHourMin(subItem[2].arrtime)}}<br><span>{{subItem[2].destination_name.slice(0,
                      -5)}}</span></p>
                </ng-container>
              </div>
            </div>
            <div class="flightTotlalPrice">
              <p>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                item.flightfare.infantbasefare + item.flightfare.adulttax +
                item.flightfare.childtax + item.flightfare.infanttax | currency: item.flightfare.currency: true: '2.0-0'
                }}</p>
              <!-- <span (click)="shoeMorefare(i)" *ngIf="!morefare[i]">More fares</span> -->
              <!-- <span (click)="shoeMorefare(i)" *ngIf="morefare[i]">Less fares</span> -->

            </div>
          </div>

          <!--More fare detail-->
          <mat-divider *ngIf="subItem[0].origin === this.flightRequest.origin"></mat-divider>
          <!-- <ng-container *ngIf="subItem[0].origin === this.flightRequest.origin">
            <div class="fare-holder" *ngIf="morefare[i]">
              <div class="super-save">
                <div class="super">
                  <div class="radio-holder" (click)="togglePrice('superSaver')">
                    <mat-radio-button value="1" [checked]="selectedPriceType === 'superSaver'">Super Saver</mat-radio-button>
                  </div>
                  <div class="pricing">
                    <span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                      item.flightfare.infantbasefare + item.flightfare.adulttax +
                      item.flightfare.childtax + item.flightfare.infanttax | currency: item.flightfare.currency: true:
                      '2.0-0' }}</span>
                  </div>
                </div>
                <div class="item-incl" [ngClass]="{'switchicon': selectedPriceType === 'superSaver'}">
                  <mat-list class="item-lst" role="list">
                    <mat-list-item role="listitem">Cabin baggage included</mat-list-item>
                    <mat-list-item role="listitem">Cancellation fees apply</mat-list-item>
                    <mat-list-item role="listitem">Check-in baggage included</mat-list-item>
                    <mat-list-item role="listitem">Date change chargeable</mat-list-item>
                  </mat-list>
                </div>

              </div>
              <div class="super-save">
                <div class="super">
                  <div class="radio-holder" (click)="togglePrice('flexPlus')">
                    <mat-radio-button value="1" [checked]="selectedPriceType === 'flexPlus'">Flexi Plus</mat-radio-button>
                  </div>

                  <div class="pricing">
                    <span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                      item.flightfare.infantbasefare + item.flightfare.adulttax +
                      item.flightfare.childtax + item.flightfare.infanttax | currency: item.flightfare.currency: true:
                      '2.0-0' }}</span>
                  </div>
                </div>
                <div class="item-incl" [ngClass]="{'switchicon': selectedPriceType === 'flexPlus'}">
                  <mat-list class="item-lst" role="list">
                    <mat-list-item role="listitem">Cabin baggage included</mat-list-item>
                    <mat-list-item role="listitem">Lower cancellation fees </mat-list-item>
                    <mat-list-item role="listitem"> Check-in baggage included</mat-list-item>
                    <mat-list-item role="listitem">Free date change allowed</mat-list-item>
                    <mat-list-item role="listitem">Free seats available</mat-list-item>
                  </mat-list>
                </div>

              </div>
              <div class="super-save">
                <div class="super">
                  <div class="radio-holder" (click)="togglePrice('easyRefund')">
                    <mat-radio-button value="1" [checked]="selectedPriceType === 'easyRefund'">Easy Refund</mat-radio-button>
                  </div>

                  <div class="pricing">
                    <span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                      item.flightfare.infantbasefare + item.flightfare.adulttax +
                      item.flightfare.childtax + item.flightfare.infanttax | currency: item.flightfare.currency: true:
                      '2.0-0' }}</span>
                  </div>
                </div>
                <div class="item-incl" [ngClass]="{'switchicon': selectedPriceType === 'easyRefund'}">
                  <mat-list class="item-lst" role="list">
                    <mat-list-item role="listitem">Cabin baggage included</mat-list-item>
                    <mat-list-item role="listitem">Date change chargeable</mat-list-item>
                    <mat-list-item role="listitem">Check-in baggage included </mat-list-item>
                    <mat-list-item role="listitem">Full refund of upto ₹ 5,655 (over and above airline refund) per
                      person per route if you cancel</mat-list-item>

                  </mat-list>
                </div>

              </div>

            </div>

          </ng-container> -->

          <!--More fare detail ends here-->


          <div class="itineraryDetail" > <!--*ngIf="subItem[0].origin === this.flightRequest.origin"-->
            <div class="itineraryInfo">
              <div class="extraInfo">
                <ul>
                  <li class="baggage">
                    <mat-icon>luggage</mat-icon>&nbsp;
                    <ng-container *ngIf="item?.extra_info?.baggage?.length !== 0">
                      {{item.extra_info.baggage[0].value}}&nbsp;Check-In(1pc)</ng-container>
                    <ng-container *ngIf="item?.extra_info?.baggage?.length === 0"><span>No check-in luggage</span>
                    </ng-container>
                  </li>
                  <!-- Food Meal -->
                  <!-- <li class="meal">
                    <ng-container *ngIf="item?.extra_info?.change?.length !== 0">
                      <mat-icon>restaurant</mat-icon>&nbsp;{{item.extra_info.change[0].value}}
                    </ng-container>
                    <ng-container *ngIf="item?.extra_info?.change?.length === 0"><span>
                        <mat-icon>no_meals</mat-icon>&nbsp;No Meal
                      </span></ng-container>
                  </li> -->
                </ul>
              </div>
            </div>
            <!-- <button mat-button (click)="selectFistTrip(item)"> -->
            <button mat-button (click)="selectFistTrip(i)">Flight Details
              <span *ngIf="selectedFistTrip[i]">
                <mat-icon>close</mat-icon>
              </span>
              <span *ngIf="!selectedFistTrip[i]">
                <mat-icon>expand_more</mat-icon>
              </span>
            </button>
          </div>
        </div>
        <section class="flightDetailsSection" [ngClass]="{'d-block': selectedFistTrip[i]}">
          <div class="flightMoreDeatiles tabsFlightMore">
            <mat-tab-group dynamicHeight mat-align-tabs="start">
              <mat-tab label="Flight Details">
                <ng-template matTabLabel>Flight Details</ng-template>
                <ng-template matTabContent>
                  <div class="innerWrapper">
                    <ng-container *ngFor="let subItem of item['flightlegs']['0'];let i = index">
                      <div class="flightItinerary">
                        <div class="flightDitels">
                          <div class="flightInfo">
                            <img
                              [src]="subItem?.carrierImage ? subItem?.carrierImage : '../../../assets/b2c/flight/flight-dummy.png'"
                              [alt]="subItem.carriername" class="img-fluid"
                              onerror="this.src='../../../assets/b2c/flight/flight-dummy.png';">
                            <div class="carrierInfo">
                              <p class="carriername">
                                <span>{{subItem.carriername}}</span>&nbsp;({{subItem.cabinclass}})
                              </p>
                              <p>{{subItem.carrier}}-{{subItem.flightnumber}}</p>
                            </div>
                          </div>
                          <div class="extraInfo">
                            <p class="baggage">
                              <mat-icon>luggage</mat-icon>&nbsp;
                              <ng-container *ngIf="item?.extra_info?.baggage?.length !== 0">
                                {{item.extra_info.baggage[0].value}}&nbsp;Check-In(1pc)</ng-container>
                              <ng-container *ngIf="item?.extra_info?.baggage?.length === 0"><span>No check-in
                                  luggage</span>
                              </ng-container>
                            </p>
                          </div>
                        </div>
                        <div class="detailsFlightAirport">
                          <div class="flightInfoDetials">
                            <p>{{subItem.origin_name.slice(0, -5)}}</p>
                            <p class="time">{{utilities.transfromTimeToHourMin(subItem.deptime)}}</p>
                            <p class="date">{{subItem.depdate | date}}</p>
                            <p matTooltip="{{subItem.originAirportName}}">
                              {{subItem.originAirportName | slice:0:10}}...
                            </p>
                            <p>
                              Terminal {{subItem.depterminal || '-'}}
                            </p>
                          </div>
                          <div class="timeDuration">
                            <p>{{subItem.journeyduration * 1000 * 60 | date: 'h' : 'UTC'}}h {{subItem.journeyduration *
                              1000 * 60 | date: 'm' : 'UTC'}}m</p>
                            <span></span>
                          </div>
                          <div class="flightInfoDetials">
                            <p>{{subItem.destination_name.slice(0, -5)}}</p>
                            <p class="time">{{utilities.transfromTimeToHourMin(subItem.arrtime)}}</p>
                            <p class="date">{{subItem.arrdate | date}}</p>
                            <p matTooltip="{{subItem.destinationAirportName}}">
                              {{subItem.destinationAirportName | slice:0:10}}...
                            </p>
                            <p>
                              Terminal {{subItem.arrterminal || '-'}}
                            </p>
                          </div>
                        </div>
                        <p class="overLayStrip">Change of Planes |
                          {{item.layovers[0][item['flightlegs'][0][i]?.destination] |
                          date: 'H'}}h {{item.layovers[0][item['flightlegs'][0][i]?.destination] |
                          date: 'm'}}m layover in
                          {{subItem.destination_name.slice(0, -5)}}</p>
                      </div>
                    </ng-container>
                  </div>
                </ng-template>
              </mat-tab>
              <mat-tab label="Fare Summary">
                <ng-template matTabLabel>Fare Summary</ng-template>
                <ng-template matTabContent>
                  <div class="innerWrapper">
                    <div class="fareSummary">
                      <p>Base Fare<span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                          item.flightfare.infantbasefare | currency: 'INR': true : '2.0-0' }}</span>
                      </p>
                      <p>Fee & Surcharges<span>{{item.flightfare.adulttax + item.flightfare.childtax +
                          item.flightfare.infanttax
                          | currency: 'INR': true : '2.0-0' }}</span></p>
                      <p>Total Amount<span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                          item.flightfare.infantbasefare + item.flightfare.adulttax +
                          item.flightfare.childtax + item.flightfare.infanttax | currency: 'INR': true : '2.0-0' }}
                        </span></p>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
              <mat-tab label="Fare Rules"
                *ngIf="item?.extra_info?.cancel?.length !== 0 ||  item?.extra_info?.change?.length !== 0">
                <ng-template matTabLabel>Fare Rules</ng-template>
                <ng-template matTabContent>
                  <div class="innerWrapper">
                    <h4>Fare Rules</h4>
                    <div class="fareRules">
                      <h5>Airline Cancellation Fee <span> {{item.extra_info.cancel[0]?.value || 'N/A'}}</span></h5>
                      <!-- <h6>Duration<span>Per Passenger</span></h6> -->
                      <!-- <p>0-2 hours<span>Non-Refundable</span></p> -->
                      <!-- <p>2h-4days<span>3,500</span></p> -->
                      <p>{{item.extra_info.cancel[0]?.rule}}</p>
                    </div>
                    <div class="fareRules">
                      <h5>Airline Date Change Fee <span> {{item.extra_info.change[0]?.value || 'N/A'}}</span></h5>
                      <!-- <h6>Duration<span>Per Passenger</span></h6> -->
                      <!-- <p>2h-4days<span>3,500</span></p> -->
                      <p>{{item.extra_info.change[0]?.rule}}</p>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </section>
      </mat-card>
    </div>

    <div class="roundTripCol">
      <mat-card *ngFor="let item of domesticFlightJourneys[1]?.flightjourneys;let i = index" class="listFligt"
        [ngClass]="{'selected': selectedItemRound == item}" (click)="selectRound(item)">
        <div matRipple matRippleCentered *ngFor="let subItem of item.flightlegs"
          [ngClass]="{'selected': selectedItemRound == subItem}">
          <!-- *ngIf="subItem[subItem.length - 1].destination === this.flightRequest.origin" -->
          <div class="flightInformation" >
            <div class="flightInfo">
              <img
                [src]="subItem[0]?.carrierImage ? subItem[0]?.carrierImage : '../../../assets/b2c/flight/flight-dummy.png'"
                [alt]="subItem[0].carriername" class="img-fluid"
                onerror="this.src='../../../assets/b2c/flight/flight-dummy.png';">
              <div class="carrierInfo">
                <p class="carriername" [matTooltip]="subItem[0].carriername">{{subItem[0].carriername}}</p>
                <p class="carrierNumber">{{subItem[0].carrier}}-{{subItem[0].flightnumber}}
                  <span *ngIf="subItem.length === 2"
                    class="stopageVia">,<br>{{subItem[1].carrier}}-{{subItem[1].flightnumber}}</span>
                  <span *ngIf="subItem.length === 3"
                    class="stopageVia">,<br>{{subItem[2].carrier}}-{{subItem[2].flightnumber}}</span>
                </p>
              </div>
            </div>
            <div class="flightTimeInfo">
              <div class="middleFirst">
                <p>{{utilities.transfromTimeToHourMin(subItem[0].deptime)}}<br><span>{{subItem[0].origin_name.slice(0,
                    -5)}}</span></p>
              </div>
              <div class="middleSecond">
                <div class="timeDuration">
                  <p>{{item.totaljourneyduration * 1000 * 60 | date: 'H' : 'UTC'}}h {{item.totaljourneyduration * 1000 *
                    60 | date: 'm' : 'UTC'}}m
                  </p>
                  <!-- <p *ngIf="subItem.length === 1">{{subItem[0].journeyduration * 1000 * 60 | date: 'HH:mm' : 'UTC'}}
                  </p>
                  <p *ngIf="subItem.length === 2">{{subItem[0].journeyduration + subItem[1].journeyduration * 1000 *
                    60 | date: 'HH:mm' : 'UTC'}}</p>
                  <p *ngIf="subItem.length === 3">{{subItem[0].journeyduration + subItem[2].journeyduration * 1000 *
                    60 | date: 'HH:mm' : 'UTC'}}</p> -->
                  <div class="distanceLine">
                    <span></span>
                    <span *ngIf="subItem.length === 2" class="stopagePoint"><span></span></span>
                  </div>
                  <ng-container>
                    <p *ngIf="subItem.length === 1" class="stopageVia">Non stop</p>
                    <p *ngIf="subItem.length === 2" class="stopageVia"><b>1 stop</b> via
                      {{subItem[1].origin_name.slice(0,
                      -5)}}</p>
                    <p *ngIf="subItem.length === 3" class="stopageVia" matTooltip=" {{subItem[1].origin_name.slice(0,
                        -5)}} and {{subItem[2]?.origin_name.slice(0, -5)}}"><b>2 stops </b>via
                      {{subItem[1].origin_name.slice(0,
                      -5)}}
                      and ...
                    </p>
                  </ng-container>
                </div>
              </div>
              <div class="middleThird">
                <!-- {{subItem | json}} -->
                <ng-container>
                  <p *ngIf="subItem.length === 1">
                    {{utilities.transfromTimeToHourMin(subItem[0].arrtime)}}<br><span>{{subItem[0].destination_name.slice(0,
                      -5)}}</span></p>
                  <p *ngIf="subItem.length === 2">
                    {{utilities.transfromTimeToHourMin(subItem[1].arrtime)}}<br><span>{{subItem[1].destination_name.slice(0,
                      -5)}}</span></p>
                  <p *ngIf="subItem.length === 3">
                    {{utilities.transfromTimeToHourMin(subItem[2].arrtime)}}<br><span>{{subItem[2].destination_name.slice(0,
                      -5)}}</span></p>
                </ng-container>
              </div>
            </div>
            <div class="flightTotlalPrice">
              <p>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                item.flightfare.infantbasefare + item.flightfare.adulttax +
                item.flightfare.childtax + item.flightfare.infanttax | currency: 'INR': true : '2.0-0' }}</p>
              <!-- <span (click)="shoeMorefareReturn(i)" *ngIf="!morefareReturn[i]">More fares</span> -->
              <!-- <span (click)="shoeMorefareReturn(i)" *ngIf="morefareReturn[i]">Less fares</span> -->
            </div>
          </div>
          <!--More fare detail-->
          <mat-divider *ngIf="subItem[subItem.length - 1].destination === this.flightRequest.origin"></mat-divider>
          <!-- <ng-container *ngIf="subItem[subItem.length - 1].destination === this.flightRequest.origin">
            <div class="fare-holder" *ngIf="morefareReturn[i]">
              <div class="super-save">
                <div class="super">
                  <div class="radio-holder" (click)="togglePrice('superSaver')">
                    <mat-radio-button value="1" [checked]="selectedPriceType === 'superSaver'">Super Saver</mat-radio-button>
                  </div>
                  <div class="pricing">
                    <span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                      item.flightfare.infantbasefare + item.flightfare.adulttax +
                      item.flightfare.childtax + item.flightfare.infanttax | currency: item.flightfare.currency: true:
                      '2.0-0' }}</span>
                  </div>
                </div>
                <div class="item-incl" [ngClass]="{'switchicon': selectedPriceType === 'superSaver'}">
                  <mat-list class="item-lst" role="list">
                    <mat-list-item role="listitem">Cabin baggage included</mat-list-item>
                    <mat-list-item role="listitem">Cancellation fees apply</mat-list-item>
                    <mat-list-item role="listitem">Check-in baggage included</mat-list-item>
                    <mat-list-item role="listitem">Date change chargeable</mat-list-item>
                  </mat-list>
                </div>

              </div>
              <div class="super-save">
                <div class="super">
                  <div class="radio-holder" (click)="togglePrice('flexPlus')">
                    <mat-radio-button value="1" [checked]="selectedPriceType === 'flexPlus'">Flexi Plus</mat-radio-button>
                  </div>

                  <div class="pricing">
                    <span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                      item.flightfare.infantbasefare + item.flightfare.adulttax +
                      item.flightfare.childtax + item.flightfare.infanttax | currency: item.flightfare.currency: true:
                      '2.0-0' }}</span>
                  </div>
                </div>
                <div class="item-incl" [ngClass]="{'switchicon': selectedPriceType === 'flexPlus'}">
                  <mat-list class="item-lst" role="list">
                    <mat-list-item role="listitem">Cabin baggage included</mat-list-item>
                    <mat-list-item role="listitem">Lower cancellation fees </mat-list-item>
                    <mat-list-item role="listitem"> Check-in baggage included</mat-list-item>
                    <mat-list-item role="listitem">Free date change allowed</mat-list-item>
                    <mat-list-item role="listitem">Free seats available</mat-list-item>
                  </mat-list>
                </div>

              </div>
              <div class="super-save">
                <div class="super">
                  <div class="radio-holder" (click)="togglePrice('easyRefund')">
                    <mat-radio-button value="1" [checked]="selectedPriceType === 'easyRefund'">Easy Refund</mat-radio-button>
                  </div>

                  <div class="pricing">
                    <span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                      item.flightfare.infantbasefare + item.flightfare.adulttax +
                      item.flightfare.childtax + item.flightfare.infanttax | currency: item.flightfare.currency: true:
                      '2.0-0' }}</span>
                  </div>
                </div>
                <div class="item-incl" [ngClass]="{'switchicon': selectedPriceType === 'easyRefund'}">
                  <mat-list class="item-lst" role="list">
                    <mat-list-item role="listitem">Cabin baggage included</mat-list-item>
                    <mat-list-item role="listitem">Date change chargeable</mat-list-item>
                    <mat-list-item role="listitem">Check-in baggage included </mat-list-item>
                    <mat-list-item role="listitem">Full refund of upto ₹ 5,655 (over and above airline refund) per
                      person per route if you cancel</mat-list-item>
                  </mat-list>
                </div>

              </div>

            </div>

          </ng-container> -->

          <!--More fare detail ends here-->
          <div class="itineraryDetail" > <!--*ngIf="subItem[subItem.length - 1].destination === this.flightRequest.origin"-->
            <div class="itineraryInfo">
              <div class="extraInfo">
                <ul>
                  <li class="baggage">
                    <mat-icon>luggage</mat-icon>&nbsp;
                    <ng-container *ngIf="item?.extra_info?.baggage?.length !== 0">
                      {{item.extra_info.baggage[0].value}}&nbsp;Check-In(1pc)</ng-container>
                    <ng-container *ngIf="item?.extra_info?.baggage?.length === 0"><span>No check-in luggage</span>
                    </ng-container>
                  </li>
                  <!-- Food Meal -->
                  <!-- <li class="meal">
                    <ng-container *ngIf="item?.extra_info?.change?.length !== 0">
                      <mat-icon>restaurant</mat-icon>&nbsp;{{item.extra_info.change[0].value}}
                    </ng-container>
                    <ng-container *ngIf="item?.extra_info?.change?.length === 0">
                      <span>
                        <mat-icon>no_meals</mat-icon>&nbsp;No Meal
                      </span>
                    </ng-container>
                  </li> -->
                </ul>
              </div>
            </div>
            <!-- <button mat-button (click)="selectRoundTrip(item)"> -->
            <button mat-button (click)="selectRoundTrip(i)">Flight Details
              <span *ngIf="selectedRoundItem[i]">
                <mat-icon>close</mat-icon>
              </span>
              <span *ngIf="!selectedRoundItem[i]">
                <mat-icon>expand_more</mat-icon>
              </span>
            </button>

          </div>
        </div>
        <section class="flightDetailsSection" [ngClass]="{'d-block': selectedRoundItem[i]}">
          <div class="flightMoreDeatiles tabsFlightMore">
            <mat-tab-group dynamicHeight mat-align-tabs="start">
              <mat-tab label="Flight Details">
                <ng-template matTabLabel>Flight Details</ng-template>
                <ng-template matTabContent>
                  <div class="innerWrapper">
                    <ng-container *ngFor="let subItem of item['flightlegs']['0']; let i = index">
                      <div class="flightItinerary">
                        <div class="flightDitels">
                          <div class="flightInfo">
                            <img
                              [src]="subItem?.carrierImage ? subItem?.carrierImage : '../../../assets/b2c/flight/flight-dummy.png'"
                              [alt]="subItem.carriername" class="img-fluid"
                              onerror="this.src='../../../assets/b2c/flight/flight-dummy.png';">
                            <div class="carrierInfo">
                              <p class="carriername">
                                <span>{{subItem.carriername}}</span>&nbsp;({{subItem.cabinclass}})
                              </p>
                              <p>{{subItem.carrier}}-{{subItem.flightnumber}}</p>
                            </div>
                          </div>
                          <div class="extraInfo">
                            <p class="baggage">
                              <mat-icon>luggage</mat-icon>&nbsp;
                              <ng-container *ngIf="item?.extra_info?.baggage?.length !== 0">
                                {{item.extra_info.baggage[0].value}}&nbsp;Check-In(1pc)</ng-container>
                              <ng-container *ngIf="item?.extra_info?.baggage?.length === 0"><span>No check-in
                                  luggage</span>
                              </ng-container>
                            </p>
                          </div>
                        </div>
                        <div class="detailsFlightAirport">
                          <div class="flightInfoDetials">
                            <p>{{subItem.origin_name.slice(0, -5)}}</p>
                            <p class="time">{{utilities.transfromTimeToHourMin(subItem.deptime)}}</p>
                            <p class="date">{{subItem.depdate | date}}</p>
                            <p matTooltip="{{subItem.originAirportName}}">
                              {{subItem.originAirportName | slice:0:10}}...
                            </p>
                            <p>
                              Terminal {{subItem.depterminal || '-'}}
                            </p>
                          </div>
                          <div class="timeDuration">
                            <p>{{subItem.journeyduration * 1000 * 60 | date: 'h' : 'UTC'}}h {{subItem.journeyduration *
                              1000 * 60 | date: 'm' : 'UTC'}}m</p>
                            <span></span>
                          </div>
                          <div class="flightInfoDetials">
                            <p>{{subItem.destination_name.slice(0, -5)}}</p>
                            <p class="time">{{utilities.transfromTimeToHourMin(subItem.arrtime)}}</p>
                            <p class="date">{{subItem.arrdate | date}}</p>
                            <p matTooltip="{{subItem.destinationAirportName}}">
                              {{subItem.destinationAirportName | slice:0:10}}...
                            </p>
                            <p>
                              Terminal {{subItem.arrterminal || '-'}}
                            </p>
                          </div>
                        </div>
                        <p class="overLayStrip">Change of Planes |
                          {{item.layovers[0][item['flightlegs'][0][i]?.destination] |
                          date: 'H'}}h {{item.layovers[0][item['flightlegs'][0][i]?.destination] |
                          date: 'm'}}m layover in
                          {{subItem.destination_name.slice(0, -5)}}</p>
                      </div>
                    </ng-container>
                  </div>
                </ng-template>
              </mat-tab>
              <mat-tab label="Fare Summary">
                <ng-template matTabLabel>Fare Summary</ng-template>
                <ng-template matTabContent>
                  <div class="innerWrapper">
                    <div class="fareSummary">
                      <p>Base Fare<span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                          item.flightfare.infantbasefare | currency: 'INR': true : '2.0-0' }}</span>
                      </p>
                      <p>Fee & Surcharges<span>{{item.flightfare.adulttax + item.flightfare.childtax +
                          item.flightfare.infanttax
                          | currency: 'INR': true : '2.0-0' }}</span></p>
                      <p>Total Amount<span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                          item.flightfare.infantbasefare + item.flightfare.adulttax +
                          item.flightfare.childtax + item.flightfare.infanttax | currency: 'INR': true : '2.0-0' }}
                        </span></p>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
              <mat-tab label="Fare Rules"
                *ngIf="item?.extra_info?.cancel?.length !== 0 ||  item?.extra_info?.change?.length !== 0">
                <ng-template matTabLabel>Fare Rules</ng-template>
                <ng-template matTabContent>
                  <div class="innerWrapper">
                    <h4>Fare Rules</h4>
                    <div class="fareRules">
                      <h5>Airline Cancellation Fee <span> {{item.extra_info.cancel[0]?.value || 'N/A'}}</span></h5>
                      <!-- <h6>Duration<span>Per Passenger</span></h6> -->
                      <!-- <p>0-2 hours<span>Non-Refundable</span></p> -->
                      <!-- <p>2h-4days<span>3,500</span></p> -->
                      <p>{{item.extra_info.cancel[0]?.rule}}</p>
                    </div>
                    <div class="fareRules">
                      <h5>Airline Date Change Fee <span> {{item.extra_info.change[0]?.value || 'N/A'}}</span></h5>
                      <!-- <h6>Duration<span>Per Passenger</span></h6> -->
                      <!-- <p>2h-4days<span>3,500</span></p> -->
                      <p>{{item.extra_info.change[0]?.rule}}</p>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </section>
      </mat-card>
    </div>
  </section>
</div>
<ng-container *ngIf="isLoaded && domesticFlightJourneys && domesticFlightJourneys?.length > 0">
  <section class="roundTripBooking" *ngIf="!visible">
    <div class="container">
      <div class=" wrapper">
        <div class="flightDetileSelected">
          <div class="innerWrapper">
            <h4>Departure</h4>
            <ng-container *ngIf="singleTrip as item">
              <div class="flightInfo">
                <div class="logInfo">
                  <img
                    [src]="item.flightlegs[0][0].carrierImage ? item.flightlegs[0][0].carrierImage : '../../../assets/b2c/flight/flight-dummy.png'"
                    alt="" onerror="this.src='../../../assets/b2c/flight/flight-dummy.png';">
                  <div class="flightName">
                    <p>{{item.flightlegs[0][0].carriername}}</p>
                    <a (click)="showFlightDetails = !showFlightDetails">Flight Details</a>
                  </div>
                </div>
                <div class="flightTime">
                  <p><span>{{utilities.transfromTimeToHourMin(item.flightlegs[0][0].deptime)}}</span> <img
                      src="../../../../assets/svgIcon/arrow_long_right_w.svg">
                    <span
                      *ngIf="item.flightlegs[0].length ==1">{{utilities.transfromTimeToHourMin(item.flightlegs[0][0].arrtime)}}</span>
                    <span
                      *ngIf="item.flightlegs[0].length ==2">{{utilities.transfromTimeToHourMin(item.flightlegs[0][1].arrtime)}}</span>
                    <span
                      *ngIf="item.flightlegs[0].length ==3">{{utilities.transfromTimeToHourMin(item.flightlegs[0][2].arrtime)}}</span>

                  </p>
                </div>
                <div class="priceTotle">
                  <p>{{item.flightfare?.totalnet | currency: 'INR': true : '2.0-0'}}</p>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="innerWrapper">
            <h4>Arrival</h4>
            <ng-container *ngIf="roundTrip as item">
              <div class="flightInfo">
                <div class="logInfo">
                  <img
                    [src]="item.flightlegs[0][0].carrierImage ? item.flightlegs[0][0].carrierImage : '../../../assets/b2c/flight/flight-dummy.png'"
                    alt="" onerror="this.src='../../../assets/b2c/flight/flight-dummy.png';">
                  <div class="flightName">
                    <p>{{item.flightlegs[0][0].carriername}}</p>
                    <a (click)="showFlightDetails = !showFlightDetails">Flight Details</a>
                  </div>
                </div>
                <div class="flightTime">
                  <p><span>{{utilities.transfromTimeToHourMin(item.flightlegs[0][0].deptime)}}</span><img
                      src="../../../../assets/svgIcon/arrow_long_right_w.svg">
                    <span
                      *ngIf="item.flightlegs[0].length ==1">{{utilities.transfromTimeToHourMin(item.flightlegs[0][0]?.arrtime)}}</span>
                    <span
                      *ngIf="item.flightlegs[0].length ==2">{{utilities.transfromTimeToHourMin(item.flightlegs[0][1]?.arrtime)}}</span>
                    <span
                      *ngIf="item.flightlegs[0].length ==3">{{utilities.transfromTimeToHourMin(item.flightlegs[0][2]?.arrtime)}}</span>
                  </p>
                </div>
                <div class="priceTotle">
                  <p>{{item.flightfare?.totalnet | currency: 'INR': true : '2.0-0'}}</p>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="totalRoundTrip">
            <p>{{singleTripTotal + roundTripTotal | currency: 'INR': true : '2.0-0'}}</p>
          </div>
        </div>
        <button mat-button class="secoundaryBtn" (click)="bookNow()">Book Now</button>
      </div>
      <section class="flightMoreDetils" *ngIf="showFlightDetails">
        <button mat-icon-button (click)="showFlightDetails = !showFlightDetails" color="primary" class="closeBtn">
          <mat-icon>close</mat-icon>
        </button>
        <section class="wrapperInnerFlight">
          <mat-tab-group mat-align-tabs="start">
            <mat-tab label="Flight Details">
              <ng-template matTabContent>
                <div class="innerWrapper">
                  <div class="inner">

                    <ng-container *ngIf="singleTrip as item">
                      <div class="flightItinerary">
                        <div class="flightDitels">
                          <div class="flightInfo">
                            <img
                              [src]="item.flightlegs[0][0].carrierImage ? item.flightlegs[0][0].carrierImage : '../../../assets/b2c/flight/flight-dummy.png'"
                              [alt]="item.flightlegs[0][0].carriername" class="img-fluid"
                              onerror="this.src='../../../assets/b2c/flight/flight-dummy.png';">
                            <div class="carrierInfo">
                              <p class="carriername">
                                <span>{{item.flightlegs[0][0].carriername}}</span>&nbsp;({{item.flightlegs[0][0].cabinclass}})
                              </p>
                              <p>{{item.flightlegs[0][0].carrier}}-{{item.flightlegs[0][0].flightnumber}}</p>
                            </div>
                          </div>
                          <div class="extraInfo">
                            <p class="baggage">
                              <ng-container *ngIf="item?.extra_info?.baggage?.length !== 0">
                                <mat-icon>luggage</mat-icon>&nbsp;{{item.extra_info.baggage[0].value}}&nbsp;Check-In(1pc)
                              </ng-container>
                              <ng-container *ngIf="item?.extra_info?.baggage?.length === 0">
                                <span>
                                  <mat-icon>luggage</mat-icon>&nbsp;No check-in luggage
                                </span>
                              </ng-container>
                            </p>
                          </div>
                        </div>
                        <ng-container *ngIf="item['flightlegs'][0][0] as subItem">
                          <div class="flightInfoTime">
                            <div class="flightInfo">
                              <p>{{subItem.origin_name.slice(0, -5)}}</p>
                              <p class="timeFlight">{{utilities.transfromTimeToHourMin(subItem.deptime)}}</p>
                              <p class="dateFlight">{{subItem.depdate | date}}</p>
                            </div>
                            <div class="timeDuration">
                              <p>{{subItem.journeyduration * 1000 * 60 | date: 'h' : 'UTC'}}h {{subItem.journeyduration *
                                1000 * 60 | date: 'm' : 'UTC'}}m</p> <span></span>
                            </div>
                            <div class="flightInfo">
                              <p>{{subItem.destination_name.slice(0, -5)}}</p>
                              <p class="timeFlight">{{utilities.transfromTimeToHourMin(subItem.arrtime)}}</p>
                              <p class="dateFlight">{{subItem.arrdate | date}}</p>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                      <ng-container *ngIf="item['flightlegs'][0][1] as subItem;">
                        <p class="overLayStrip">Change of Planes | {{item.layovers[0][item['flightlegs'][0][1].origin]
                          | date: 'H'}}h {{item.layovers[0][item['flightlegs'][0][1].origin]
                          | date: 'm'}}m layover in {{subItem.origin_name.slice(0, -5)}}
                        </p>
                        <div class="flightItinerary">
                          <div class="flightDitels">
                            <div class="flightInfo">
                              <img
                                [src]="item.flightlegs[0][1].carrierImage ? item.flightlegs[0][1].carrierImage : '../../../assets/b2c/flight/flight-dummy.png'"
                                [alt]="item.flightlegs[0][1].carriername" class="img-fluid"
                                onerror="this.src='../../../assets/b2c/flight/flight-dummy.png';">
                              <div class="carrierInfo">
                                <p class="carriername">
                                  <span>{{item.flightlegs[0][0].carriername}}</span>&nbsp;({{item.flightlegs[0][1].cabinclass}})
                                </p>
                                <p>{{item.flightlegs[0][1].carrier}}-{{item.flightlegs[0][1].flightnumber}}</p>
                              </div>
                            </div>
                            <div class="extraInfo">
                              <p class="baggage">
                                <ng-container *ngIf="item?.extra_info?.baggage?.length !== 0">
                                  <mat-icon>luggage</mat-icon>
                                  &nbsp;{{item.extra_info.baggage[0].value}}&nbsp;Check-In(1pc)
                                </ng-container>
                                <ng-container *ngIf="item?.extra_info?.baggage?.length === 0">
                                  <span>
                                    <mat-icon>luggage</mat-icon>&nbsp;No check-in luggage
                                  </span>
                                </ng-container>
                              </p>
                            </div>
                          </div>
                          <ng-container *ngIf="item['flightlegs'][0][1] as subItem">
                            <div class="flightInfoTime">
                              <div class="flightInfo">
                                <p>{{subItem.origin_name.slice(0, -5)}}</p>
                                <p class="timeFlight">{{utilities.transfromTimeToHourMin(subItem.deptime)}}</p>
                                <p class="dateFlight">{{subItem.depdate | date}}</p>
                              </div>
                              <div class="timeDuration">
                                <p>{{subItem.journeyduration * 1000 * 60 | date: 'h' : 'UTC'}}h {{subItem.journeyduration
                                  *
                                  1000 * 60 | date: 'm' : 'UTC'}}m</p> <span></span>
                              </div>
                              <div class="flightInfo">
                                <p>{{subItem.destination_name.slice(0, -5)}}</p>
                                <p class="timeFlight">{{utilities.transfromTimeToHourMin(subItem.arrtime)}}</p>
                                <p class="dateFlight">{{subItem.arrdate | date}}</p>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                  <div class="inner">
                    <ng-container *ngIf="roundTrip as item">
                      <div class="flightItinerary">
                        <div class="flightDitels">
                          <div class="flightInfo">
                            <img
                              [src]="item.flightlegs[0][0].carrierImage ? item.flightlegs[0][0].carrierImage : '../../../assets/b2c/flight/flight-dummy.png'"
                              [alt]="item.flightlegs[0][0].carriername" class="img-fluid"
                              onerror="this.src='../../../assets/b2c/flight/flight-dummy.png';">
                            <div class="carrierInfo">
                              <p class="carriername">
                                <span>{{item.flightlegs[0][0].carriername}}</span>&nbsp;({{item.flightlegs[0][0].cabinclass}})
                              </p>
                              <p>{{item.flightlegs[0][0].carrier}}-{{item.flightlegs[0][0].flightnumber}}</p>
                            </div>
                          </div>
                          <div class="extraInfo">
                            <p class="baggage">
                              <ng-container *ngIf="item?.extra_info?.baggage?.length !== 0">
                                <mat-icon>luggage</mat-icon>&nbsp;{{item.extra_info.baggage[0].value}}&nbsp;Check-In(1pc)
                              </ng-container>
                              <ng-container *ngIf="item?.extra_info?.baggage?.length === 0">
                                <span>
                                  <mat-icon>luggage</mat-icon>&nbsp;No check-in luggage
                                </span>
                              </ng-container>
                            </p>
                          </div>
                        </div>
                        <ng-container *ngIf="item['flightlegs'][0][0] as subItem">
                          <div class="flightInfoTime">
                            <div class="flightInfo">
                              <p>{{subItem.origin_name.slice(0, -5)}}</p>
                              <p class="timeFlight">{{utilities.transfromTimeToHourMin(subItem.deptime)}}</p>
                              <p class="dateFlight">{{subItem.depdate | date}}</p>
                            </div>
                            <div class="timeDuration">
                              <p>{{subItem.journeyduration * 1000 * 60 | date: 'h' : 'UTC'}}h {{subItem.journeyduration *
                                1000 * 60 | date: 'm' : 'UTC'}}m</p> <span></span>
                            </div>
                            <div class="flightInfo">
                              <p>
                                {{subItem.destination_name.slice(0, -5)}}
                              </p>
                              <p class="timeFlight">{{utilities.transfromTimeToHourMin(subItem.arrtime)}}</p>
                              <p class="dateFlight">{{subItem.arrdate | date}}</p>
                            </div>
                          </div>
                        </ng-container>
                      </div>

                      <ng-container *ngIf="item['flightlegs'][0][1] as subItem">
                        <p class="overLayStrip">Change of Planes |
                          {{item.layovers[0][item['flightlegs'][0][1].origin]
                          |date: 'H'}}h {{item.layovers[0][item['flightlegs'][0][1].origin]
                          |date: 'm'}}m layover in {{subItem.origin_name.slice(0, -5)}}
                        </p>
                        <div class="flightItinerary">
                          <div class="flightDitels">
                            <div class="flightInfo">
                              <img
                                [src]="item.flightlegs[0][0].carrierImage ? item.flightlegs[0][0].carrierImage : '../../../assets/b2c/flight/flight-dummy.png'"
                                alt="" class="img-fluid"
                                onerror="this.src='../../../assets/b2c/flight/flight-dummy.png';">
                              <div class="carrierInfo">
                                <p class="carriername">
                                  <span>{{item.flightlegs[0][0].carriername}}</span>&nbsp;({{item.flightlegs[0][0].cabinclass}})
                                </p>
                                <p>{{item.flightlegs[0][1].carrier}}-{{item.flightlegs[0][1].flightnumber}}</p>
                              </div>
                            </div>
                            <div class="extraInfo">
                              <p class="baggage">
                                <ng-container *ngIf="item?.extra_info?.baggage?.length !== 0">
                                  <mat-icon>luggage</mat-icon>
                                  &nbsp;{{item.extra_info.baggage[0].value}}&nbsp;Check-In(1pc)
                                </ng-container>
                                <ng-container *ngIf="item?.extra_info?.baggage?.length === 0">
                                  <span>
                                    <mat-icon>luggage</mat-icon>&nbsp;No check-in luggage
                                  </span>
                                </ng-container>
                              </p>
                            </div>
                          </div>
                          <ng-container *ngIf="item['flightlegs'][0][1] as subItem">
                            <div class="flightInfoTime">
                              <div class="flightInfo">
                                <p>{{subItem.origin_name.slice(0, -5)}}</p>
                                <p class="timeFlight">{{utilities.transfromTimeToHourMin(subItem.deptime)}}</p>
                                <p class="dateFlight">{{subItem.depdate | date}}</p>
                              </div>
                              <div class="timeDuration">
                                <p>{{subItem.journeyduration * 1000 * 60 | date: 'h' : 'UTC'}}h {{subItem.journeyduration
                                  *
                                  1000 * 60 | date: 'm' : 'UTC'}}m</p> <span></span>
                              </div>
                              <div class="flightInfo">
                                <p>{{subItem.destination_name.slice(0, -5)}}</p>
                                <p class="timeFlight">{{utilities.transfromTimeToHourMin(subItem.arrtime)}}</p>
                                <p class="dateFlight">{{subItem.arrdate | date}}</p>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab label="Fare Summary" *ngIf="singleTrip as item">
              <ng-template matTabContent>
                <div class="footer_fare_summary">
                  <div class="innerWrapper">
                    <div class="fareSummary">
                      <p class="text">Fare Summary Single Trip</p>
                      <p>Base Fare<span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                          item.flightfare.infantbasefare | currency: 'INR': true : '2.0-0' }}</span>
                      </p>
                      <p>Fee & Surcharges<span>{{item.flightfare.adulttax + item.flightfare.childtax +
                          item.flightfare.infanttax
                          | currency: 'INR': true : '2.0-0' }}</span></p>
                      <p>Total Amount<span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                          item.flightfare.infantbasefare + item.flightfare.adulttax +
                          item.flightfare.childtax + item.flightfare.infanttax | currency: 'INR': true : '2.0-0' }}
                        </span></p>
                    </div>
                  </div>
                  <div class="innerWrapper" *ngIf="roundTrip as item">
                    <div class="fareSummary">
                      <p class="text">Fare Summary Round Trip</p>
                      <p>Base Fare<span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                          item.flightfare.infantbasefare | currency: 'INR': true : '2.0-0' }}</span>
                      </p>
                      <p>Fee & Surcharges<span>{{item.flightfare.adulttax + item.flightfare.childtax +
                          item.flightfare.infanttax
                          | currency: 'INR': true : '2.0-0' }}</span></p>
                      <p>Total Amount<span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                          item.flightfare.infantbasefare + item.flightfare.adulttax +
                          item.flightfare.childtax + item.flightfare.infanttax | currency: 'INR': true : '2.0-0' }}
                        </span></p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-tab>
            <mat-tab label="Fare Rules" *ngIf="singleTrip as item">
              <ng-template matTabContent>
                <div class="footer_fare_summary footer_fareRules">
                  <div class="fareSummary footer_fare">
                    <p class="text">Fare Rules</p>
                    <div class="fareRules">
                      <h5>Airline Cancellation Fee <span>{{item.extra_info.cancel[0]?.value || 'N/A'}}</span></h5>
                      <p>{{item.extra_info.cancel?.rule}}</p>
                    </div>
                    <div class="fareRules">
                      <h5>Airline Date Change Fee <span> {{item.extra_info.change[0]?.value || 'N/A'}}
                        </span></h5>
                      <p>{{item.extra_info.change[0]?.rule}}</p>
                    </div>
                  </div>
                  <div class="innerWrapper" *ngIf="roundTrip as item">
                    <div class="fareSummary footer_fare ">
                      <p class="text">Fare Rules</p>
                      <div class="fareRules">
                        <h5>Airline Cancellation Fee <span> {{item.extra_info.cancel[0]?.value || 'N/A'}}</span></h5>
                        <p>{{item.extra_info.cancel?.rule || 'N/A'}}</p>
                      </div>
                      <div class="fareRules">
                        <h5>Airline Date Change Fee <span> {{item.extra_info.change[0]?.value || 'N/A'}}
                          </span></h5>
                        <p>{{item.extra_info.change[0]?.rule}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-tab>

          </mat-tab-group>
        </section>
      </section>
    </div>
  </section>
  <section class="roundTripBooking" *ngIf="visi">
    <div class="container">
      <div class=" wrapper">
        <div class="flightDetileSelected">
          <div class="totalmobview">
            <p>Total Amount</p>
            <p>{{singleTripTotal + roundTripTotal | currency: 'INR': true : '2.0-0'}}</p>
          </div>
        </div>
        <button mat-button class="secoundaryBtn resbtn" (click)="bookNow()">Book Now</button>
      </div>
    </div>
  </section>
</ng-container>

<ng-container
  *ngIf="!(loaderService.isLoading | async) && !domesticFlightJourneys || (domesticFlightJourneys && domesticFlightJourneys.length === 0)">
  <div class="no_results-wrapper" *ngIf="this.isLoaded == true">
    <mat-card>
      <div class="error-wrapper text-center">
        <div class="no-results-img d-flex justify-content-center">
          <img src="../../../assets/b2c/flight/result-not-found.png" class="img-fluid">
        </div>
        <h1>No results found</h1>
        <p>
          Sorry! We could not find any flight for this search. Please search again
        </p>
        <div class="search_btn">
          <button mat-button class="secoundaryBtn">Search again</button>
        </div>

      </div>
    </mat-card>
  </div>
</ng-container>
